import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

interface IProps {
  value: number
  setValue: (value: number) => void
}

export default function NumberInput({ value, setValue }: IProps) {
  const [inputValue, setInputValue] = useState<string>('')

  useEffect(() => {
    if (value === 0 && inputValue !== '') {
      setInputValue('')
    } else if (value !== 0) {
      setInputValue(value.toString())
    }
  }, [value])

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newValue = event.target.value

    if (newValue === '') {
      setInputValue('')
      setValue(0)
      return
    }

    if (/^\d+$/.test(newValue)) {
      setInputValue(newValue)
      setValue(parseInt(newValue, 10))
    }
  }

  return <Container inputMode="numeric" onChange={onChange} pattern="[0-9]*" type="text" value={inputValue} />
}

const Container = styled.input`
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 4px;
  color: #000000;
  display: flex;
  flex-direction: column;
  height: 20px;
  justify-content: flex-start;
  text-align: center;
  width: 24px;
`
